// OwnerPortalShell.tsx — الغلاف المستقلّ لبوابة الملّاك (Owner_Portal_UX_Redesign_Plan_2026-07-12.md
// §3). لا شريط جانبيّ ولا إطار البطاقة العائمة المستعار من واجهة الإدارة — خلفيّة كاملة العرض
// (full-bleed) + شريط علويّ (OwnerTopBar، ≥640px) + شريط سفليّ (OwnerBottomNav، <640px). كل صفحة
// تُقيِّد عرض محتواها بنفسها عبر OwnerPageContainer (لا هنا) ليتمكّن أي باند علويّ (كالترحيب) من
// الامتداد كامل العرض خلف المحتوى المُقيَّد.
import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OwnerTopBar } from './OwnerTopBar';
import { OwnerBottomNav } from './OwnerBottomNav';

export function OwnerPortalShell() {
	const { i18n } = useTranslation();
	const isRtl = i18n.language === 'ar';

	return (
		<div dir={isRtl ? 'rtl' : 'ltr'} className="flex min-h-screen flex-col bg-background">
			<OwnerTopBar />
			<main className="flex-1">
				<Outlet />
			</main>
			<OwnerBottomNav />
		</div>
	);
}
